import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dribbble-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-2.5 3.5-23 31.1-71.6 49.4-22.4-41.1-47.2-74.9-51-80 43.3-10.5 89 0.8 122.6 30.6zM140.1 364c14.3-29.2 53-66.8 108.1-85.6 19.2 49.8 27.2 91.6 29.2 103.6-44 18.7-96.8 13.6-137.3-18zM238.9 255.8c-49.4 13.9-94.3 53.9-116.5 91.8-21.8-24.3-35.1-56.3-35.1-91.4 0-1.4 0.1-2.8 0.1-4.2 6 0.2 72.2 1 140.4-19.4 3.9 7.7 7.7 15.4 11.1 23.2zM273.8 272.1c42.8-6.9 80.5 4.3 85.1 5.8-6.1 38-27.9 70.9-58.6 91.6-1.4-8.3-8.6-48.3-26.5-97.4zM253.5 223.7c50.5-20.7 73.4-50 76.3-53.9 19.1 23.2 30.6 52.8 30.9 85.1-4.5-1-49.7-10.1-95.2-4.4-3.7-9-7.2-17-12-26.8zM448 80v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM384 256c0-88.2-71.8-160-160-160s-160 71.8-160 160 71.8 160 160 160 160-71.8 160-160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dribbble-square.js
// module id = 798
// module chunks = 0